import { employeeModal } from "../../../redux/slice/employeeSlice";
import { useDispatch } from "react-redux";
import Modal from "../../elements/Modal";
import Button from "../../form/Button";

export default function EmpAddType({
  empAddType,
  setEmpAddtype = () => {},
  setUploadModal = () => {},
}) {
  const dispatch = useDispatch();

  return (
    <Modal
      title={"Employees"}
      size="lg"
      open={empAddType?.isOpen}
      onClose={() => {
        setEmpAddtype((pre) => ({ ...pre, isOpen: false }));
      }}
      modaltitleClasses={"text-[15px]"}
      headerClass={"!bg-black dark:!bg-slate-800 !rounded-t-lg !text-white dark:!text-slate-400"}
      childrenClasses={"!rounded-b-lg"}
    >
      <div className="w-full p-0 md:p-3 flex flex-col md:flex-row justify-center items-center gap-4">
        <Button
          buttonLabel={"Bulk CSV Upload"}
          buttonIcon={"fa-regular fa-file-excel"}
          buttonIconPosition={"left"}
          buttonClasses={"!z-0 !rounded-full"}
          buttonFunction={() => {
            setEmpAddtype({ data: {}, isOpen: false });
            setUploadModal({ isOpen: true });
          }}
        />
        <p className="font-semibold text-slate-900 dark:text-slate-400">or</p>
        <Button
          buttonLabel={"Add Individual Employee"}
          buttonIcon={"fa-regular fa-user"}
          buttonIconPosition={"left"}
          buttonClasses={"!z-0 !rounded-full"}
          buttonFunction={() => {
            setEmpAddtype({ data: {}, isOpen: false });
            dispatch(employeeModal({ isOpen: true }));
          }}
        />
      </div>
    </Modal>
  );
}
